import { useAtom } from "jotai"
import { permissionsAtom } from "@store/authAtoms"
import { useLazyGetPermissionsQuery } from "@store/services/accessService"
import { useEffect } from "react"

const usePermissions = () => {
  const [permissions, setPermissions] = useAtom(permissionsAtom)
  const [fetchPermissions, { data: fetchedPermissions, isFetching }] = useLazyGetPermissionsQuery()

  useEffect(() => {
    if (isFetching || !fetchedPermissions) return
    setPermissions(fetchedPermissions)
  }, [fetchedPermissions, isFetching, setPermissions])

  return { permissions, refetch: fetchPermissions }
}

export default usePermissions
